var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list_tab",attrs:{"role":"tablist"}},_vm._l((_vm.list),function(item,idx){return _c('tab-item',{key:idx,attrs:{"item":item,"selected":_vm.value === idx},on:{"click":function($event){return _vm.select(idx, item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }